<form class="entry-page-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" novalidate>
    <h2 class="title">Please set your new password</h2>

    <div class="form-group">
        <label class="form-label">New password:</label>
        <input
            type="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': form.controls.password.errors && message }"
            formControlName="password"
        />
    </div>

    <div class="form-group">
        <label class="form-label">Confirm password:</label>
        <input
            type="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': form.controls.confirm_password.errors && message }"
            formControlName="confirm_password"
        />
    </div>
    <div class="login-buttons"><button class="btn ch-button full-width" type="submit">CHANGE PASSWORD</button></div>
    <div class="error-message" *ngIf="message">{{ message }}</div>
</form>
